import {Directive, ElementRef, Output, EventEmitter, Input} from '@angular/core';

@Directive({
    selector: '[appClickOutside]'
})

export class ClickOutsideDirective {
    @Output()
    public clickOutside = new EventEmitter();
    @Input()
    set isActive(isActive: any) {
        if (isActive) {
            this.elementRef.nativeElement.closest('body').addEventListener("click", this.eventListenerFunction.bind(this));
        } else {
            this.elementRef.nativeElement.closest('body').removeEventListener('click', this.eventListenerFunction.bind(this));
        }
    }

    constructor(private elementRef: ElementRef) {
    }

    eventListenerFunction(e) {
        const targetElement = e.target;
        const clickedInside = this.elementRef.nativeElement.contains(targetElement);
        if (!clickedInside && this.clickOutside) {
            this.clickOutside.emit(null);
        }
    }
}
